import { useEffect, useState } from 'react'
import AddressAutocomplete from './AddressAutocomplete'

const emptyAddress = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zip: '',
  country: 'United States',
  lat: null,
  lng: null,
}

export default function ShipElsewhereModal({ initial, onSave, onClose }) {
  const [addr, setAddr] = useState(() => ({
    ...emptyAddress,
    ...(initial || {}),
  }))

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  const canSave =
    (addr.addressLine1 || '').trim().length > 2 &&
    (addr.city || '').trim().length > 1

  return (
    <div
      className="ship-elsewhere-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      <div className="ship-elsewhere-card">
        <h2 className="ship-elsewhere-title">Ship somewhere else</h2>
        <AddressAutocomplete
          value={addr}
          onChange={(partial) => setAddr((a) => ({ ...a, ...partial }))}
        />
        <input
          type="text"
          className="field-input"
          placeholder="Suite, apt, floor"
          autoComplete="address-line2"
          style={{ marginTop: 8 }}
          value={addr.addressLine2 || ''}
          onChange={(e) =>
            setAddr((a) => ({ ...a, addressLine2: e.target.value }))
          }
        />
        <div className="ship-elsewhere-actions">
          <button
            type="button"
            className="ship-elsewhere-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="ship-elsewhere-save"
            disabled={!canSave}
            onClick={() => {
              if (!canSave) return
              onSave(addr)
            }}
          >
            Save address
          </button>
        </div>
      </div>
    </div>
  )
}
